import React from 'react';
import {getFieldComponent} from "../helpers";

function FormField(props) {
    const FieldComponent = getFieldComponent(props.type);

    return (
        <div className={(props.hidden || (props.editMode && props.hideOnEdit)) ? "hidden" : "mt-4"}>
            <FieldComponent {...props}/>

            {props.error &&
            <div className="text-red-700">
                {props.error}
            </div>
            }
        </div>
    )
}

export default FormField;